import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import { ChakraProvider } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { BrowserRouter } from "react-router-dom";

import App from "./Pages";
import { AuthProvider } from "./Context/Auth/AuthContext";
import { CookiesProvider } from "react-cookie";
import { GlobalProvider } from "./Context/Global/GlobalContext";

const AppContainer = styled.div`
  font-family: "M PLUS Rounded 1c";
`;

ReactDOM.render(
  <ChakraProvider>
    <AppContainer>
      <CookiesProvider>
        <BrowserRouter>
          <AuthProvider>
            <GlobalProvider>
              <React.StrictMode>
                <App />
              </React.StrictMode>
            </GlobalProvider>
          </AuthProvider>
        </BrowserRouter>
      </CookiesProvider>
    </AppContainer>
  </ChakraProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
